import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'silos'
const verb = 'put'

export default class OspreySilosUpdate extends BaseAction {
    constructor(dataKey) {
        const id = '4ad5a60c-46dd-4c17-a53e-2d2f99d0ff81'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    update(silo) {
        if (!silo) {
            throw new Error('Missing silo object')
        }

        this.path = `/${resource}/${silo.id.value}`

        this.params = {
            silo
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/silos/silos-update.js